(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(sectionEl) {
    var carouselEl = sectionEl.querySelector('[data-carousel]'); if (!carouselEl) return;
    var track = sectionEl.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(track.children);
    var total = slides.length; if (!total) return;

    // read settings
    var autoplay = carouselEl.dataset.autoplay === 'true';
    var interval = Math.max(500, Math.min(9999, parseInt(carouselEl.dataset.interval, 10) || 4000));
    var showDots = carouselEl.dataset.showDots === 'true';
    var showArrows = carouselEl.dataset.showArrows === 'true';
    var slidesDesktop = parseInt(carouselEl.dataset.slidesDesktop, 10) || 3;
    var slidesMobile = parseInt(carouselEl.dataset.slidesMobile, 10) || 1;
    var imageHeight = parseInt(carouselEl.dataset.imageHeight, 10) || 260;
    var imageMaxWidthPct = parseInt(carouselEl.dataset.imageMaxwidth, 10) || 100;
    var imageWidthMode = carouselEl.dataset.imageWidthMode || 'full';
    var imageRatio = carouselEl.dataset.imageRatio || 'adapt';
    var textAlign = carouselEl.dataset.textAlign || 'left';

    // apply image sizing
    function applyImageSizing() {
      slides.forEach(function (s) {
        var media = s.querySelector('[data-media]');
        if (!media) return;
        media.style.height = imageHeight + 'px';
        var pct = 100;
        if (imageWidthMode === 'wide') pct = 90;
        if (imageWidthMode === 'medium') pct = 75;
        if (imageWidthMode === 'small') pct = 60;
        media.style.maxWidth = pct + '%';
      });
    }

    // slides per view based on viewport
    function currentSlidesToShow() {
      return (window.innerWidth <= 740) ? Math.min(slidesMobile, total) || 1 : Math.min(slidesDesktop, total) || 1;
    }

    var lastSlideWidth = 0;
    var index = 0;
    var timer = null;
    var isPlaying = false;
    var dots = [];
    var dotsContainer = sectionEl.querySelector('[data-dots]');

    function applySlideWidths() {
      var slidesToShow = currentSlidesToShow();
      var containerWidth = carouselEl.clientWidth;
      var computed = window.getComputedStyle(track);
      var gapPx = parseFloat(computed.gap) || 0;
      var totalVisibleGaps = Math.max(0, slidesToShow - 1) * gapPx;
      var slideWidth = Math.floor((containerWidth - totalVisibleGaps) / slidesToShow) || Math.floor(containerWidth / slidesToShow);
      lastSlideWidth = slideWidth;

      slides.forEach(function (s) {
        s.style.flex = '0 0 ' + slideWidth + 'px';
        s.style.width = slideWidth + 'px';
        s.style.maxWidth = slideWidth + 'px';
      });

      var trackWidth = slideWidth * slides.length + gapPx * Math.max(0, slides.length - 1);
      track.style.width = Math.ceil(trackWidth) + 'px';

      var maxIndex = Math.max(0, slides.length - slidesToShow);
      if (index > maxIndex) index = maxIndex;
      setPosition();
    }

    function setPosition() {
      var slidesToShow = currentSlidesToShow();
      var computed = window.getComputedStyle(track);
      var gapPx = parseFloat(computed.gap) || 0;
      var slideWidth = lastSlideWidth || (slides[0] && slides[0].getBoundingClientRect().width) || 0;
      var step = slideWidth + gapPx;
      var maxIndex = Math.max(0, slides.length - slidesToShow);
      if (index > maxIndex) index = maxIndex;
      var translatePx = -(index * step);
      track.style.transform = 'translate3d(' + translatePx + 'px,0,0)';
      updateAria();
      updateDots();
    }

    // page-advance prev/next
    function prev() {
      var slidesToShow = currentSlidesToShow();
      index = Math.max(0, index - slidesToShow);
      setPosition();
    }
    function next() {
      var slidesToShow = currentSlidesToShow();
      var maxIndex = Math.max(0, slides.length - slidesToShow);
      index = (index >= maxIndex) ? 0 : Math.min(maxIndex, index + slidesToShow);
      setPosition();
    }

    function updateAria() {
      var slidesToShow = currentSlidesToShow();
      slides.forEach(function (slide, i) {
        var visible = (i >= index && i < index + slidesToShow);
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    // create dots below (pages)
    function createDots() {
      // dotsContainer sits where we rendered .carousel-dots in HTML (below carousel)
      dotsContainer = sectionEl.querySelector('.carousel-dots[data-dots]');
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      dots = [];
      var slidesToShow = currentSlidesToShow();
      var pages = Math.max(1, Math.ceil((slides.length) / slidesToShow));
      for (var i = 0; i < pages; i++) {
        var pageIndex = i * slidesToShow;
        var b = document.createElement('button');
        b.className = 'carousel-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('data-dot-index', pageIndex);
        b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        b.type = 'button';
        (function (idx) {
          b.addEventListener('click', function () {
            index = idx;
            resetAutoplay();
            setPosition();
          });
        })(pageIndex);
        dotsContainer.appendChild(b);
        dots.push(b);
      }
      updateDots();
    }

    function updateDots() {
      if (!dots.length) return;
      var slidesToShow = currentSlidesToShow();
      var activePage = Math.floor(index / slidesToShow);
      dots.forEach(function (d, i) {
        if (i === activePage) d.classList.add('is-active'); else d.classList.remove('is-active');
      });
    }

    // arrows
    if (showArrows) {
      var prevBtn = sectionEl.querySelector('[data-prev]'); var nextBtn = sectionEl.querySelector('[data-next]');
      if (prevBtn && nextBtn) { prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); }); nextBtn.addEventListener('click', function () { next(); resetAutoplay(); }); }
    }

    function startAutoplay() { if (!autoplay || isPlaying) return; isPlaying = true; timer = setInterval(function () { next(); }, interval); }
    function stopAutoplay() { if (!isPlaying) return; clearInterval(timer); timer = null; isPlaying = false; }
    function resetAutoplay() { stopAutoplay(); startAutoplay(); }

    sectionEl.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { prev(); resetAutoplay(); } if (e.key === 'ArrowRight') { next(); resetAutoplay(); } });

    // swipe (page)
    (function () {
      var startX = 0, dist = 0, threshold = 30, allowedTime = 500, startTime = 0;
      track.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; startX = t.pageX; startTime = new Date().getTime(); }, false);
      track.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; dist = t.pageX - startX; var elapsed = new Date().getTime() - startTime;
        if (elapsed <= allowedTime) { if (Math.abs(dist) >= threshold) { if (dist < 0) { next(); } else { prev(); } resetAutoplay(); } }
      }, false);
    })();

    // images loaded
    function imagesLoaded(callback) {
      var imgs = track.querySelectorAll('img'); if (!imgs.length) return callback();
      var count = imgs.length, done = 0;
      function check() { done++; if (done >= count) callback(); }
      imgs.forEach(function (img) { if (img.complete) check(); else { img.addEventListener('load', check); img.addEventListener('error', check); } });
    }

    var resizeTimeout;
    window.addEventListener('resize', function () { clearTimeout(resizeTimeout); resizeTimeout = setTimeout(function () { applyImageSizing(); applySlideWidths(); createDots(); }, 120); });

    // apply alignment classes
    slides.forEach(function (s) {
      var content = s.querySelector('.carousel-slide__content'); if (!content) return;
      content.classList.remove('carousel-text--left','carousel-text--center','carousel-text--right');
      content.classList.add('carousel-text--' + textAlign);
    });

    applyImageSizing();
    imagesLoaded(function () { applySlideWidths(); createDots(); setPosition(); startAutoplay(); });
  }

  // init all carousels on page
  document.querySelectorAll('[data-carousel]').forEach(function (el) { initCarousel(el.closest('section') || el); });

  // Shopify editor reload support
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (evt) {
      var section = evt.detail || evt.target; if (!section) return;
      if (section.querySelector && section.querySelector('[data-carousel]')) initCarousel(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup-2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
